import axios from 'axios';
import router from '../router';

let state = {

}

const actions = {
    async check_toDos_at_addOnPartModal_storeAction({ rootState,rootGetters }) {
        try {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
            await this.dispatch('inputsManual/get_motordetailsSelection_storeAction', 'zlw');
            await this.dispatch('inputsManual/get_tractionSheavedetailsSelection_storeAction', {type: 'zlw', show: true});
            if (rootGetters['inputsManual/hasMotorManualData'] == false  || rootState.ropeGuardManual.ropeGuardDetailsSelected == null) {

                await this.dispatch('manualHome/check_configurationManual_Exist_storeAction', rootState.manualHome.configurationOverviewsManualId);
            }
            if (rootState.manualHome.kid == null || rootState.manualHome.configurationOverviewsManualId == null) {
                router.push('../manualStep/ManualHome');
            }
            await this.dispatch('inputsManual/get_suppliesSelections_storeAction');
        }
        catch { }
        finally {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },
}

const mutations = {

}

export const addOnPartModal = {
    namespaced: true,
    components: {
        axios,
    },
    state,
    actions,
    mutations
}